export default "__VITE_PUBLIC_ASSET__26e9a175__"